import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { IParlamentarianPagedRequest } from '../../../../model/sge/parlamentarian/request/parlamentarian-paged-request';
import { IParlamentarianAddEditRequest } from '../../../../model/sge/parlamentarian/request/parlamentarian-add-edit-request';
import { IParlamentarianPagedResponse } from '../../../../model/sge/parlamentarian/response/parlamentarian-paged-response';
import { IParlamentarianResponse } from '../../../../model/sge/parlamentarian/response/parlamentarian-response';

const defaultPath = 'Parlamentarian';

const list = async (params: IParlamentarianPagedRequest): Promise<Pagination<IParlamentarianPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params
    }).then((response) => Object.assign(new Pagination<IParlamentarianPagedResponse>(), response.data));
};

const getById = async (id: number): Promise<IParlamentarianResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IParlamentarianAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    });
};

const edit = async (id: number, params: IParlamentarianAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    });
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const ParlamentarianAppService = { list, getById, add, edit, remove };
export default ParlamentarianAppService;
